import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialCareerComponent } from './career.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    MaterialCareerComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    FormsModule
  ],
  exports: [MaterialCareerComponent]
})
export class MaterialCareerModule {}